import * as React from "react";
import moment from "moment";

import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import HealingIcon from "@mui/icons-material/Healing";

import {statusOptions} from "@/utils/constants";
import PlayerAvatar from "@/components/PlayerAvatar";
import {getPlayerMainRosterName} from "@/utils/functions";

import "./index.scss";

function ContractBadge({contract}) {
	if (!contract?.endDate) return null;

	const endDate = moment(contract.endDate);
	const now = moment();
	const monthsLeft = endDate.diff(now, "months");
	const year = endDate.format("YYYY");

	let colorClass = "contract-safe";
	if (monthsLeft < 0) colorClass = "contract-expired";
	else if (monthsLeft <= 12) colorClass = "contract-critical";
	else if (monthsLeft <= 24) colorClass = "contract-warning";

	return <div className={`contract-badge ${colorClass}`}>{year}</div>;
}

export default function RosterPlayerCard(props) {
	const {element, handleDelete, onJerseyEdit, showRoster} = props;
	const [editingJersey, setEditingJersey] = React.useState(false);
	const [jerseyValue, setJerseyValue] = React.useState(
		element?.jerseyNumber || "",
	);

	const type =
		element?.goalkeeper !== undefined || element?.primaryRole || element?.player
			? "player"
			: "staff";
	const rosterElement =
		type === "player" ? element?.player || element : element?.staff || element;

	const currentStatus = statusOptions?.filter(
		(o) => o.value === rosterElement?.status,
	)?.[0];

	const contract = element?.contractData || null;
	const mainRosterName =
		type === "player" ? getPlayerMainRosterName(rosterElement) : null;

	return (
		<div className="roster-player-card-container">
			{type === "player" && <ContractBadge contract={contract} />}
			{type === "player" && rosterElement?.hasActiveInjury && (
				<div className="injury-badge" title="Infortunio/malattia in corso">
					<HealingIcon sx={{fontSize: 11}} />
					Ind.
				</div>
			)}
			<div className="roster-player-card-info">
				<div className="info-team">
					<PlayerAvatar
						firstName={rosterElement?.firstName}
						lastName={rosterElement?.lastName}
						imageUrl={rosterElement?.imageUrl}
						status={rosterElement?.hasActiveInjury ? "critical" : undefined}
						statusLabel={
							rosterElement?.hasActiveInjury ? "Infortunato" : undefined
						}
					/>
					{currentStatus && currentStatus.value !== "Interno" ? (
						<div className="status">{currentStatus?.label}</div>
					) : null}
				</div>
				<div className="info-title">
					<div className="d-flex flex-column w-100">
						<div className="d-flex align-items-center gap-1">
							<div className="info-name">
								{rosterElement.firstName + " " + rosterElement.lastName}
							</div>
							{type === "player" && onJerseyEdit ? (
								editingJersey ? (
									<input
										autoFocus
										type="number"
										className="jersey-input"
										value={jerseyValue}
										onChange={(e) => setJerseyValue(e.target.value)}
										onBlur={() => {
											onJerseyEdit(element, jerseyValue || null);
											setEditingJersey(false);
										}}
										onKeyDown={(e) => {
											if (e.key === "Enter") e.target.blur();
											if (e.key === "Escape") {
												setJerseyValue(element?.jerseyNumber || "");
												setEditingJersey(false);
											}
										}}
										onClick={(e) => e.stopPropagation()}
									/>
								) : (
									<div
										className={`jersey-chip${element?.jerseyNumber ? " jersey-chip--set" : ""}`}
										onClick={(e) => {
											e.stopPropagation();
											setEditingJersey(true);
										}}
										title="Imposta n° di maglia"
									>
										{element?.jerseyNumber
											? `#${element.jerseyNumber}`
											: <span className="jersey-chip__add">+#</span>}
									</div>
								)
							) : null}
						</div>
						{type === "player" && (
							<div className="info-text role-text">
								{rosterElement.goalkeeper
									? "Portiere"
									: rosterElement.primaryRole}
							</div>
						)}
						{showRoster && type === "player" ? (
							mainRosterName ? (
								<div className="info-text roster-text">{mainRosterName}</div>
							) : (
								<div className="info-text no-roster-text">Nessuna rosa</div>
							)
						) : null}
						{type === "staff" && (
							<div className="info-text">{rosterElement.role}</div>
						)}
						{type === "staff" && (
							<div className="info-text">{"Area " + rosterElement.unit}</div>
						)}
						<div className="info-text dob-text">
							{rosterElement.dateOfBirth
								? moment(rosterElement.dateOfBirth).format(
										type === "player" ? "YYYY" : "DD/MM/YYYY",
									)
								: "---"}
						</div>
					</div>
				</div>
			</div>
			{handleDelete ? (
				<div className="action-container">
					<Button
						variant="outlined"
						color="error"
						size="small"
						onClick={(e) => {e.stopPropagation(); handleDelete(element.attendanceId || element.id);}}
					>
						<CloseIcon />
					</Button>
				</div>
			) : null}
		</div>
	);
}
